import React from 'react';
import {Box} from "@mui/material";
import {IconContext} from "react-icons";
import {IVoceCosto} from "../../../../../../utils/interfaces/tannery_production/order_schedule/schede_costo/IVoceCosto";
import {FaCheck} from "react-icons/fa";


const useCustomCellRenderer = (
    row: IVoceCosto,
    theme: any
) => {


    const getIconsForCustomField = (row: IVoceCosto, theme: any) => {
        const icons = [];

        icons.push(null);

        if (row.is_active) {
            icons.push(
                <FaCheck
                    title='attivo'
                    color={theme.palette.primary.light}/>,
            )
        }


        return icons;
    };

    const renderIcons = () => {
        const icons = getIconsForCustomField(row, theme);
        return (
            <IconContext.Provider value={{size: "1.3rem"}}>
                <Box display="flex" flexDirection="row" sx={{gap: 0.5}}>
                    {icons}
                </Box>
            </IconContext.Provider>


        );
    };

    return {renderIcons};
};

export default useCustomCellRenderer;